import * as i0 from '@angular/core';
import * as i1 from './shared.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
export const NbSharedModuleNgFactory:i0.NgModuleFactory<i1.NbSharedModule> = (null as any);
var _decl0_0:i2.CommonModule = (<any>(null as any));
var _decl0_1:i3.FormsModule = (<any>(null as any));
var _decl0_2:i4.RouterModule = (<any>(null as any));
var _decl0_3:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_4:i0.ElementRef<any> = (<any>(null as any));
